import React from "react";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import _ from "lodash";
import RemoveActionType from "../Enums/RemoveActionType";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Spinner } from "reactstrap";
import EmailConfigTables from "../Enums/EmailConfigTables";

const NoDataIndication = () => (
  <div class="container h-100">
    <div class="row NoDataFoundTable">
      <h5>No Data Found!</h5>
    </div>
  </div>
);

const CaptionElement = (props) => (
  <h6 className="sub_tbl_caption">{props.header}</h6>
);

const actionsColumn = (
  cell,
  row,
  confirmDeleteFacilityRep,
  setCurrentFacilityRepInfo,
  keyIdfr,
  hideActionColumn,
  showReSubscribeModal
) => {
  // Subscription actions (UnSubscribe/ReSubscribe/Block/UnBlock) only make sense
  // when there's an actual holder to act on. Driven by explicit API flags so the
  // FE doesn't have to infer state from display strings or empty fields.
  const hasHolder = !row.isVacant && !row.isPositionRemoved;
  return (
    <div className="mobileActions">
      <div className="actionIcons">
        {hideActionColumn && row.id != 0 && hasHolder && row.isactive ? (
          <button
            type="button"
            className="btn btn-danger unsubscrActionBtn mr-1"
            onClick={() => {
              confirmDeleteFacilityRep(
                row.id,
                row.positionId,
                keyIdfr,
                RemoveActionType.UnSubscribe
              );
              setCurrentFacilityRepInfo(
                row.positionName,
                row.id,
                RemoveActionType.UnSubscribe
              );
            }}
          >
            UnSubscribe
            <i
              title="UnSubscribe"
              className="fa fa-bell-slash-o cursorPointer"
            />
          </button>
        ) : hideActionColumn && row.id != 0 && hasHolder && !row.isactive ? (
          <button
            type="button"
            className="btn btn-success unsubscrActionBtn mr-1"
            disabled={row.isblocked}
            onClick={() => {
              showReSubscribeModal(row, keyIdfr, RemoveActionType.ReSubscribe);
            }}
          >
            ReSubscribe
            <i
              title="ReSubscribe"
              className="fa fa-bell-slash-o cursorPointer"
            />
          </button>
        ) : (
          ""
        )}

        {hideActionColumn && row.id != 0 && hasHolder && !row.isblocked ? (
          <button
            type="button"
            className="btn btn-danger unsubscrActionBtn mr-3"
            onClick={() => {
              confirmDeleteFacilityRep(
                row.id,
                row.positionId,
                keyIdfr,
                RemoveActionType.Block
              );
              setCurrentFacilityRepInfo(
                row.positionName,
                row.id,
                RemoveActionType.Block
              );
            }}
          >
            Block
            <i title="Block" className="fa fa-bell-slash-o cursorPointer" />
          </button>
        ) : hideActionColumn && row.id != 0 && hasHolder && row.isblocked ? (
          <button
            type="button"
            className="btn btn-success unsubscrActionBtn mr-1"
            onClick={() => {
              showReSubscribeModal(row, keyIdfr, RemoveActionType.UnBlock);
            }}
          >
            UnBlock
            <i title="UnBlock" className="fa fa-bell-slash-o cursorPointer" />
          </button>
        ) : (
          ""
        )}

        {hideActionColumn && (
          <i
            title="Remove"
            className="fas fa-trash-alt mr-2 cursorPointer text-danger"
            onClick={() => {
              confirmDeleteFacilityRep(
                row.id,
                row.positionId,
                keyIdfr,
                RemoveActionType.Delete
              );
              setCurrentFacilityRepInfo(
                row.positionName,
                row.id,
                RemoveActionType.Delete
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

const columns = (
  setCurrentFacilityRepInfo,
  confirmDeleteFacilityRep,
  keyIdfr,
  hideActionColumn,
  showReSubscribeModal
) => [
  {
    dataField: "id",
    text: "ID",
    hidden: true,
  },
  {
    dataField: "positionId",
    text: "Position ID",
    hidden: true,
  },
  {
    dataField: "positionName",
    text: "Position",
    sort: true,
  },
  {
    dataField: "memberName",
    text: "Member",
    sort: true,
    // Style by explicit API flags, not by string-matching the label.
    formatter: (cell, row) =>
      row.isVacant || row.isPositionRemoved ? (
        <span className="text-muted font-italic">{cell}</span>
      ) : (
        cell
      ),
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    formatter: (cell, row) =>
      row.isVacant || row.isPositionRemoved || !cell ? (
        <span className="text-muted font-italic">—</span>
      ) : (
        cell
      ),
  },
  {
    text: "",
    dataField: "actions",
    isDummyField: true,
    headerClasses: "text-nowrap px-sm-3 px-2 py-2",
    classes: "pl-3 pr-2 py-2",
    formatter: (cell, row) => {
      return actionsColumn(
        cell,
        row,
        confirmDeleteFacilityRep,
        setCurrentFacilityRepInfo,
        keyIdfr,
        hideActionColumn,
        showReSubscribeModal
      );
    },
    csvExport: false,
  },
];

const RemotePagination = (
  data,
  setCurrentFacilityRepInfo,
  confirmDeleteFacilityRep,
  loading,
  keyIdfr,
  caption,
  hideActionColumn,
  showReSubscribeModal
) => (
  <div
    className={`Sub_FacReps_${keyIdfr}_Tbl`}
    id={`Sub_FacReps_${keyIdfr}_Records`}
    key={`Sub_FacReps_${keyIdfr}_Records_Parent`}
  >
    <ToolkitProvider
      keyField="positionId"
      data={data}
      columns={columns(
        setCurrentFacilityRepInfo,
        confirmDeleteFacilityRep,
        keyIdfr,
        hideActionColumn,
        showReSubscribeModal
      )}
    >
      {(props) => (
        <>
          <BootstrapTable
            keyField="positionId"
            loading={!_.isEmpty(data) && loading}
            overlay={overlayFactory({
              spinner: true,
              styles: {
                overlay: (base) => ({
                  ...base,
                  background: "rgba(40, 45, 42, 0.19)",
                }),
              },
            })}
            noDataIndication={() => {
              return loading === false ? (
                <NoDataIndication />
              ) : (
                <div className="d-flex justify-content-center p-4">
                  <Spinner />
                </div>
              );
            }}
            caption={<CaptionElement header={caption} />}
            {...props.baseProps}
          />
        </>
      )}
    </ToolkitProvider>
  </div>
);

const EmailConfigFacilityRepTable = (props) => {
  const {
    listData,
    setCurrentFacilityRepInfo,
    confirmDeleteFacilityRep,
    loading,
    keyIdfr,
    caption,
    hideActionColumn,
    showReSubscribeModal,
  } = props;
  return (
    <>
      {RemotePagination(
        listData,
        setCurrentFacilityRepInfo,
        confirmDeleteFacilityRep,
        loading,
        keyIdfr,
        caption,
        hideActionColumn,
        showReSubscribeModal
      )}
    </>
  );
};

EmailConfigFacilityRepTable.propTypes = {
  listData: PropTypes.array.isRequired,
};

EmailConfigFacilityRepTable.defaultProps = {
  listData: [],
};

export default EmailConfigFacilityRepTable;
